module.exports = __webpack_public_path__ + "static/img/KLT1550-FCM-370-73PBB-1.jpg 18-04-13-786.966ae56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/KLT1550-FCM-370-73PBB-1.jpg 18-04-13-786.jpg
// module id = 6c8m
// module chunks = 0